export default "__VITE_ASSET__Fcb5yaj6__"